<script setup>
import BaseDashboardBanner from './BaseDashboardBanner.vue'
</script>

<template>
  <BaseDashboardBanner
    buttonText="Learn more"
    buttonLink="https://rbwizard.com/"
  >
    <template #background>
      <div class="biggest_feud_inner_back" />
    </template>
    <template #content>
      <div
        class="d-flex f-column"
        style="line-height: 3.05rem"
      >
        <span
          class="clr-primary weight_600"
          style="font-size: 2.4rem"
          >Check out our Rakeback deals,
        </span>
        <span
          class="weight_400"
          style="font-size: 2.4rem; color: #fff"
          >get instant rewards.</span
        >
      </div>
    </template>
  </BaseDashboardBanner>
</template>

<style lang="scss" scoped>
.biggest_feud_inner_back {
  z-index: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0%;
  z-index: -1;
  background: url('@/assets/img/app_banner_rbwizard_promo.webp');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
}
</style>
